import React, { Component } from 'react';
import {
  PuzzleDatePicker as TPDatePicker,
  Translatable
} from "puzzle";
import {
  IntlProvider,
  load,
  loadMessages,
  LocalizationProvider
} from "@progress/kendo-react-intl";
import weekData from "cldr-core/supplemental/weekData.json";
import {
  DatePickerProps
} from '@progress/kendo-react-dateinputs/dist/npm/datepicker/DatePicker';
import caGregorian from "./LocalizedDatePicker.i18n.json";
import localeMessages from "./LocaleMessages.i18n.json";

type PROPS = DatePickerProps & {
  ariaLabelLocale?: string
  errorTxt?: string,
  label: string
  labelClassName?: string
  onChange: Function
  withValidation?: boolean
};

/**
 * Translates all values
 *
 * @param inputJson
 * @param path
 */
const translateJson = (inputJson: any, path = '') => {
  let outPut: any = {};
  transformToLocale(inputJson, outPut, path);
  return outPut;
};

/**
 * Gets localized value for every non object in json.
 *
 * @param inObj
 * @param outObj
 * @param path
 */
const transformToLocale = (inObj: any, outObj: any, path: string) => {
  let keys = Object.keys(inObj);
  if (keys.length) {
    for (const [key] of Object.entries(inObj)) {
      if (typeof inObj[key] === 'object') {
        outObj[key] = {};
        let newPath = `${path}${key}.`;
        transformToLocale(inObj[key], outObj[key], newPath);
      } else if (typeof inObj[key] === 'string') {
        let translateKey = `${path}${key}`;
        let translate = translateKey;
        if (Translatable) {
          translate = Translatable.t(translateKey);
        }
        outObj[key] = translate;
      }
    }
  }
};

const localizationKey = 'customLocalization';

export default class LocalizedDatePicker extends Component<PROPS, {}> {

  constructor(props: PROPS) {
    super(props);
    let caGregorianTranslated = translateJson(caGregorian, 'translation:LocalizedDatePicker.');
    let localeMessagesTranslated = translateJson(localeMessages, 'translation:LocaleMessages.');
    load(weekData, caGregorianTranslated);
    loadMessages(localeMessagesTranslated, localizationKey);
  }

  render() {
    return (
      <LocalizationProvider language={localizationKey}>
        <IntlProvider locale={localizationKey}>
          <TPDatePicker
            {...this.props}
          />
        </IntlProvider>
      </LocalizationProvider>
    );
  }
}
